import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import CalenderInput from '../../../Component/LockerComponent/LockerCalenderInput';
import RemainDaysInput from '../../../Component/LockerComponent/RemainDaysInput';
import FetchModule from '../../Share/Network/FetchModule';
import AddPaymentOptionModal from '../../../MemberRegistration/Model/AddPaymentOptionModal';
import PaymentOptionSettingSelectBox from '../../../MemberRegistration/Model/PaymentOptionSettingSelectBox';
import PaymentOptionCustomInput from '../../../MemberRegistration/Component/PaymentOptionCustomInput';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';

export default function LockerExtendsModal(props) {
  const { 
    memberData, 
    recentlyMembership,
    lockerRendering,
    lockerData, 
    closeFn 
  } = props;

  const history = useHistory();

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  const [isLoading, setIsLoading] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [days, setDays] = useState('');
  const [originalEndDate, setOriginalEndDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [placeholder, setPlaceholder] = useState('');
  const [isHoverPrevMembership, setIsHoverPrevMembership] = useState(false);
  const [cardPrice, setCardPrice] = useState(0);
  const [cashPrice, setCashPrice] = useState(0);
  const [point, setPoint] = useState(0);

  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);

  // const StartCalenderRef = useRef();
  const EndCalenderRef = useRef();

  // Modal Page Scroll Controll //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])


  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // Init Data Setting //
  useEffect(() => {
    setOriginalEndDate(lockerData.endDate);
    setEndDate(moment(lockerData.endDate));

    if (moment(lockerData.endDate).format('YYYY.MM.DD') > moment().format('YYYY.MM.DD')) setPlaceholder((moment(lockerData.endDate).diff(moment(), 'days') + 1) + ' 일 남음');
    else if (moment(lockerData.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) setPlaceholder('0');
    else return setPlaceholder((moment().diff(moment(lockerData.endDate), 'days') + 1) + ' 일 초과중');
  }, [lockerData])

  
  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    if (className === 'MembershipName') return recentlyMembership.prevSales.itemName;
    else if (className === 'Date') return moment(recentlyMembership.prevUsage.startDate).format('YY.MM.DD') + ' - ' + moment(recentlyMembership.prevUsage.endDate).format('YY.MM.DD');
  }

  // 달력 클릭시 //
  function CalenderClick(className) {
    // if (className === 'StartCalender') EndCalenderRef.current.closeCalender();
    // else StartCalenderRef.current.closeCalender();
  }

  // Days 변경시 //
  function onChangeDays(value) {
    setDays(value);

    if (value === '') setEndDate(moment(originalEndDate));
    else setEndDate(moment(originalEndDate).add(value, 'day'));
    
  }

  // EndDate 변경시 //
  function onChangeEndDate(value) {
    setDays(value.clone().endOf('day').diff(moment(originalEndDate), 'days'));
    setEndDate(value);
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert('결제수단의 이름을 입력해주세요');
      return;
    }

    if (isLoading) {
      alert('저장을 진행중입니다');
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert('삭제를 진행중입니다');
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].price = value.replaceAll(',', '');

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: 0 });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 사용 내역 연장 모달 내에서 저장하기 버튼 클릭시 //
  function onClickSaveExtends() {
    if (isLoading) {
      alert('연장을 진행중입니다');
      return;
    }
    else if (moment().clone().format('YYYY-MM-DDTHH:mm:ss') > endDate.clone().format('YYYY-MM-DDTHH:mm:ss')) {
      alert('사용 날짜 변경은 금일 보다 이전일 수 없습니다.');
      return;
    }

    setIsLoading(true);

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }


    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }
    }

    let requestData = {
      lockerId: lockerData.id,
      usageId: lockerData.usageId,
      endDate: endDate.clone().format('YYYY-MM-DDT23:59:59'),
      merchantUid: lockerData.merchantUid,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      point: finalPoint,
      lockerPaymentOptions: finalSelectedPaymentOptions
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('locker/extend', 'POST', requestData);

        if (responseData.status === 200) {
          alert('변경이 완료되었습니다.');
          closeFn();
          lockerRendering();
          setIsLoading(false);
        }
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 활성 회원권 정보 클릭시 //
  function onClickPrevMembership() {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    let value = moment(recentlyMembership.prevUsage.endDate);
    
    setDays(moment(value.format('YYYY.MM.DD 23:59:59')).diff(moment(), 'days') + 1);
    setEndDate(value);
  }

  return (
    <TopLevelWrapper>
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      <Modal>
        <ComponentWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#232323' hover='default'>{'\"' + memberData.name + '\"' + ' - 락커 연장'}</Text>
          <DivisionLine marginTop={10} marginBottom={10} />
          {
            recentlyMembership !== undefined &&
            <RecentlyMembershipWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>활성 회원권 정보</Text>
              <RecentlyMembershipInfoWrapper>
                <MembershipInfoWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>회원권</Text>
                  <MembershipNameWrapper
                    onMouseOver={() => setIsHoverPrevMembership(true)}
                    onMouseLeave={() => setIsHoverPrevMembership(false)}
                    onClick={onClickPrevMembership}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isHoverPrevMembership ? '#FF8B48' : '#000000'} cursor='pointer'>{onCalcPrevSalesInfo('MembershipName')}</Text>
                  </MembershipNameWrapper>
                </MembershipInfoWrapper>
                <MembershipInfoWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>기간</Text>
                  <MembershipNameWrapper
                    onMouseOver={() => setIsHoverPrevMembership(true)}
                    onMouseLeave={() => setIsHoverPrevMembership(false)}
                    onClick={onClickPrevMembership}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isHoverPrevMembership ? '#FF8B48' : '#000000'} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
                  </MembershipNameWrapper>
                </MembershipInfoWrapper>
              </RecentlyMembershipInfoWrapper>
            </RecentlyMembershipWrapper>
          }
          <LayerWrapper style={{ marginTop: recentlyMembership !== undefined ? `30px` : `20px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' hover='default'>락커 번호</Text>
            <InputBox>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' hover='default'>{lockerData.lockerName}</Text>
            </InputBox>
          </LayerWrapper>
          <LayerWrapper style={{ marginTop: `13px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' hover='default'>회원 이름</Text>
            <InputBox>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' hover='default'>{lockerData.userName}</Text>
            </InputBox>
          </LayerWrapper>
          <LayerWrapper style={{ marginTop: `13px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' hover='default'>추가 일수</Text>
            <DdayInputWrapper>
              <RemainDaysInput value={days} setValue={onChangeDays} placeholder={placeholder} />
            </DdayInputWrapper>
          </LayerWrapper>
          <LayerWrapper style={{ marginTop: `13px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' hover='default'>종료일</Text>
            <CalenderInput ref={EndCalenderRef} value={endDate} setValue={onChangeEndDate} disabled={false} className='EndCalender' clickFn={CalenderClick} placeholder='종료일' width={130} />
          </LayerWrapper>
          <Text style={{ marginTop: '20px', marginBottom: '20px' }} fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' hover='default'>추가 금액</Text>
          {
            selectedPaymentOptions.map((data, index) => (
              <InnerLayerWrapper
                key={'SelectedPaymentOptions-' + index}
                marginTop={10}
                gap={10}
                style={{ zIndex: selectedPaymentOptions.length - index }}>
                <SelectOptionInputWrapper>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{'결제 수단 ' + (index === 0 ? '' : index + 1)}</Text>
                    {
                      index !== 0 &&
                      <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                        <DeleteIcon src={WhiteTrashIcon} />
                      </DeleteButton>
                    }
                  </PaymentOptionTitleWrapper>
                  <PaymentOptionSettingSelectBox
                    index={index}
                    value={data}
                    setValue={onChangeSelectedPaymentOptions}
                    options={paymentOptions}
                    disabled={paymentOptions.length === 0}
                    width={120}
                    onClickAdditionOption={onClickAdditionOption}
                    onClickDeleteOption={onClickDeleteOption} />
                </SelectOptionInputWrapper>
                <RowDivisionLine />
                <SelectOptionInputWrapper>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>받은 가격</Text>
                  </PaymentOptionTitleWrapper>
                  <UnitInputWrapper>
                    <PaymentOptionCustomInput
                      index={index}
                      value={(data.price ?? 0).toLocaleString('ko-KR')}
                      setValue={onChangePaymentOptionPrice}
                      placeholder='0'
                      disabled={false}
                      textAlign='right'
                      width={88} />
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>원</Text>
                  </UnitInputWrapper>
                </SelectOptionInputWrapper>
              </InnerLayerWrapper>
            ))
          }
          <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>+ 결제 수단 추가</AddPaymentOptionButton>
          <ButtonWrapper>
            <ExitButton onClick={closeFn}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' hover='pointer'>취소</Text>
            </ExitButton>
            <SaveButton onClick={onClickSaveExtends}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='pointer'>저장하기</Text>
            </SaveButton>
          </ButtonWrapper>
        </ComponentWrapper>
      </Modal>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.3);

  transition: all 0.3s ease-in-out;
`;

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  // width: 323px;
  // // height: 456px;
  // // height: 501px;

  // // border-radius: 30px;
  border-radius: 10px;
  background-color: #FFFFFF;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 280px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const RecentlyMembershipWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const RecentlyMembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 46%;

  gap: 4px;
`;

const MembershipNameWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden;

  &:hover {
    cursor: pointer;
  }
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 8px;

  width: 114px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #CBCBCB;
`;

const DdayInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 132px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 16px;

  margin-top: 36px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 5px;
  background-color: #F5F6F8;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 5px;
  background-color: #6DD49E;

  &:hover {
    cursor: pointer;
    background-color: #2BCB67;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;

const InnerLayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  margin-top: ${props => props.marginTop}px;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const SelectOptionInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;

  width: 100%;
  height: 1px;

  background-color: #B3B3B3;
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color #B3B3B3;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;
  
  border-radius: 5px;
  background-color: #F2F2F2;

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #CBCBCB;

  &:hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color #6DD49E;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: #EC9393;

  &:hover {
    cursor: pointer;
    background-color: #D92828;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;